import React, { useState } from "react";
import classes from "../styles/style.module.css";
import { baseURL } from "../../../assets/constants/baseUrl";

import { FaPlay } from "react-icons/fa";
import { TbHammer } from "react-icons/tb";

import HubbleButton from "./HubbleButton";
import VideoPlayer from "../../../assets/components/VideoPlayer";

import {
  convertToShamsiTime,
  convertToShamsi,
} from "../../../assets/utils/ConvertToShamsi";
import { useNavigate } from "react-router";

const getAssociationTypeInPersian = (type) => {
  const typeMapping = {
    personnel: "پرسنل",
    retired: "بازنشسته",
    contractor: "قراردادی",
    saba: "فولاد صبا",
  };

  return typeMapping[type] || "نامشخص";
};

const UploadsArbirtionElement = ({ data, present, refereed }) => {
  const [openVideo, setOpenVideo] = useState(false);
  const navigate = useNavigate();

  const fileUrl = `${baseURL}file/get/${data.file}`;
  const isVideo = data.file.toLowerCase().endsWith(".mp4");

  const handleFileOpen = () => {
    if (isVideo) {
      setOpenVideo(true);
    } else {
      window.open(fileUrl, "_blank");
    }
  };

  const userFields = [
    { label: "جنسیت", value: data.owner.gender === "male" ? "مرد" : "زن" },
    {
      label: "تاریخ تولد",
      value: data?.owner?.birthDate
        ? convertToShamsi(data.owner.birthDate)
        : "نامشخص",
    },
    { label: "کد ملی", value: data.owner.nationalCode },
    { label: "کد پرسنلی", value: data.owner.personnelCode },
    { label: "شماره تلفن", value: data.owner.phone },
    { label: "نسبت", value: data.owner.relation },
    {
      label: "نوع همکاری",
      value: getAssociationTypeInPersian(data.owner.associationType),
    },
    { label: "آدرس", value: data?.personal?.address },
    { label: "شهر", value: data.personal?.city },
    { label: "استان", value: data.personal?.state },
    { label: "کد پستی", value: data.personal?.postalcode },
    { label: "محل کار", value: data.personal?.workplace },
    {
      label: "وضعیت تاهل",
      value: data.personal?.marriageStatus === "single" ? "مجرد" : "متاهل",
    },
  ];

  return (
    <div className={classes.myUploadContainer}>
      <div className={classes.videoBg}>
        <img src="/images/hubble/hubbleVideoBg.jpg" alt="video-bg" />
        <div className={classes.playIconContainer} onClick={handleFileOpen}>
          <div className={classes.play}>
            <FaPlay className="ml-1" onClick={handleFileOpen} />
          </div>
        </div>
      </div>
      <div className="row mt-5 mb-4">
        <div className="col-6">رشته </div>
        <div className="col-6 justify-content-end d-flex">
          <div className="d-flex flex-column justify-content-center align-items-end text-left">
            <span>{data.major}</span>
          </div>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-6">تاریخ:</div>
        <div className="col-6 justify-content-end d-flex">
          <div className="d-flex flex-column justify-content-center align-items-end font-weight-bold text-left">
            <span>
              {convertToShamsi(data.createdAt) +
                " " +
                convertToShamsiTime(data.createdAt)}
            </span>
          </div>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-6">نام و نام خانودگی</div>
        <div className="col-6 justify-content-end d-flex">
          <div className="d-flex flex-column justify-content-center align-items-end">
            <span className="text-left">{data.owner.fullName}</span>
          </div>
        </div>
      </div>
      {present &&
        userFields.map((field, index) => (
          <div className="row mb-4" key={index}>
            <div className="col-6">{field.label}</div>
            <div className="col-6 justify-content-end d-flex">
              <div className="d-flex flex-column justify-content-center align-items-end">
                <span className="text-left">{field.value}</span>
              </div>
            </div>
          </div>
        ))}
      {!present && (
        <div className="mt-5 mb-4 row">
          <div className="col-12">
            {refereed ? (
              <HubbleButton
                style={{ border: "2px solid var(--hubbleAccentColor)" }}
                onClick={() => navigate(`/hubble/judge/edit/${data._id}`)}
              >
                <TbHammer fontSize={20} className="ml-1" />
                ویرایش
              </HubbleButton>
            ) : (
              <HubbleButton
                style={{ border: "2px solid var(--hubbleAccentColor)" }}
                onClick={() => navigate(`/hubble/judge/${data._id}`)}
              >
                <TbHammer fontSize={20} className="ml-1" />
                داوری اثر
              </HubbleButton>
            )}
          </div>
        </div>
      )}

      {isVideo && (
        <VideoPlayer
          open={openVideo}
          closeHandler={() => setOpenVideo(false)}
          videoUrl={fileUrl}
        />
      )}
    </div>
  );
};

export default UploadsArbirtionElement;
